<template>
  <exportTemplate ref="exportTemplate" placement="top" :formModel="formModel" :table-data="tableList" :summary-data="tableSummaryData" :table-total="paginationTotal" :table-load="tableLoading" @set-custom-columns="setCustomColumns" @close-custom-columns="closeCustomColumns" @pagination-change="paginationChange" @form-submit="formSubmit" @form-reset="formReset" @sort="sortChange" @table-export="tableExport" @row-dblclick="rowDblclick">
    <template #form>
      <el-form-item label="日期范围" prop="billDate.selected">
        <date-picker v-model="formModel.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></date-picker>
      </el-form-item>
      <el-form-item label="供应商" prop="customer.selected">
        <select-multiple :select-data="formModel.customer"></select-multiple>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="formModel.clearCustomer.selected" true-label="Y" false-label="N">仅展示未结算的供应商</el-checkbox>
      </el-form-item>
    </template>
    <template>
      <el-table-column label="供应商" prop="customerName" width="150" fixed></el-table-column>
      <el-table-column label="期初金额" prop="startAmt" width="110" v-if="customColumnList['startAmt']" sortable="custom"></el-table-column>
      <el-table-column label="期初预付" prop="startPrePay" width="110" v-if="customColumnList['startPrePay']" sortable="custom"></el-table-column>
      <el-table-column label="新增预付" prop="prePayAmt" width="110" v-if="customColumnList['prePayAmt']" sortable="custom"></el-table-column>
      <el-table-column label="使用预付" prop="payPrePayAmt" width="110" v-if="customColumnList['payPrePayAmt']" sortable="custom"></el-table-column>
      <el-table-column label="预付余额" prop="prePayBanalce" width="110" v-if="customColumnList['prePayBanalce']" sortable="custom"></el-table-column>
      <el-table-column label="期初应付" prop="startArrear" width="110" v-if="customColumnList['startArrear']" sortable="custom"></el-table-column>
      <el-table-column label="新增应付" prop="arrearAmt" width="110" v-if="customColumnList['arrearAmt']" sortable="custom"></el-table-column>
      <el-table-column label="应付减少" prop="payArrearAmt" width="110" v-if="customColumnList['payArrearAmt']" sortable="custom"></el-table-column>
      <el-table-column label="应付余额" prop="arrearBanalce" width="110" v-if="customColumnList['arrearBanalce']" sortable="custom"></el-table-column>
      <el-table-column label="期末余额" prop="endAmt" width="110" v-if="customColumnList['endAmt']" sortable="custom"></el-table-column>
    </template>
  </exportTemplate>
</template>

<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
import datePicker from '@/components/common/datePicker.vue'
import { pickerOptions, getNowFormatDate, getAddDate, getQueryItem, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
  name: 'mainAccount',
  components: {
    exportTemplate,
    datePicker
  },
  data() {
    return {
      pickerOptions,
      params: {
        page: 1,
        size: 10,
        customerID: '',
        beginDate: getAddDate(-3),
        endDate: getNowFormatDate()
      },
      formModel: {
        billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
        customer: { submitName: 'customerID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择供应商', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: {page: 1, size: 5, customerType: 'V'}, text: '', value: '' }},
        clearCustomer: { submitName: 'clearCustomer', selected: 'N' },
      },
      paginationTotal: 0,
      tableList: [],
      tableLoading: false,
      tableSummaryData: {},
      customColumnsList: [
        {
            "label":"期初金额",
            "prop":"startAmt"
        },
        {
            "label":"期初预付",
            "prop":"startPrePay"
        },
        {
            "label":"新增预付",
            "prop":"prePayAmt"
        },
        {
            "label":"使用预付",
            "prop":"payPrePayAmt"
        },
        {
            "label":"预付余额",
            "prop":"prePayBanalce"
        },
        {
            "label":"期初应付",
            "prop":"startArrear"
        },
        {
            "label":"新增应付",
            "prop":"arrearAmt"
        },
        {
            "label":"应付减少",
            "prop":"payArrearAmt"
        },
        {
            "label":"应付余额",
            "prop":"arrearBanalce"
        },
        {
            "label":"期末余额",
            "prop":"endAmt"
        }
      ],
      customColumn: [],
    }
  },
  created() {
    this.getCustomColumnsList()
    this.getTableList()
  },
  computed: {
        customColumnList() {
            let tempItem = {}
            this.customColumn.forEach(i => {
                tempItem[i.prop] = (i.isShow == 'Y')
            })
            return tempItem
        }
    },
  methods: {
    setCustomColumns(el) {
        let tempArr = [...this.customColumn]
        el.loading = false
        el.setCustomcolumns(tempArr)
    },
    closeCustomColumns(el) {
        el.$nextTick(async () => {
            let { customColumns } = el
            const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
                funcCode: 417,
                customSetInfo: JSON.stringify(customColumns)
            }))

            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
        })
    },
    async getCustomColumnsList() {
        const { data: res } = await this.$http.post(
            "Account/dataSearchVue/selectColumnByFuncCode.html",
            this.Qs.stringify({ funcCode: 417 })
        );
        if (res.code != "success") return this.$confirm(res.message, "提示", {
            confirmButtonText: "确定",
            showCancelButton: false,
            type: "error",
        });
        let result = JSON.parse(res.result);
        let arr = [];
        this.customColumnsList.forEach((item) => {
            result.forEach(($item) => {
                if (item.prop == $item.prop) {
                    arr.push({
                        id: $item.id,
                        label: item.label,
                        prop: item.prop,
                        isShow: $item.isShow,
                    });
                }
            });
        });
        this.customColumn = [...arr]
    },
    paginationChange({page, size, isGetTable = true}) {
      this.params.page = page
      this.params.size = size
      if (isGetTable) {
        this.getTableList()
      }
    },
    formSubmit() {
      this.params = { ...this.params, ...getQueryItem(this.formModel) }
      this.getTableList()
    },
    formReset() {
      this.params['sortField'] = ''
      this.params['softBy'] = ''
      this.params.page = 1
    },
    async getTableList() {
      // this.tableList = [{customerName: 'fsdf',customerID: 45}]
      this.tableLoading = true
      this.tableData = []
      const { data: res } = await this.$post(
        "/erpnew/account/c/reada46ceb/purPayBalanceController/selectPurPayBalanceList.html",
        this.params
      )
      this.tableLoading = false
      if (res.code != '0') return this.$message.error(res.message)
      let { data, sum, total } = res.data
      this.paginationTotal = total
      this.tableSummaryData = sum
      this.tableList = data
    },
    sortChange({ sortField, sortBy }) {
      this.params['sortField'] = sortField
      this.params['sortBy'] = sortBy
      this.params.page = 1
      this.getTableList()
    },
    tableExport(tabColumn) {
      exportExcelCommonForVue(this.params, tabColumn, '/erpnew/account/c/reada46ceb/purPayBalanceController/selectPurPayBalanceListExport.html')
      console.log(tabColumn)
    },
    rowDblclick({ row }) {
      let options = this.Qs.stringify({
        billDate: this.formModel.billDate.selected,
        customer: { text: row.customerName, value: row.customerID }
      })
      let url = `/templates/vue-account/dist/index.htm#/dataSearchSupplierReconciliationDetailed?${options}`
      this.$refs.exportTemplate.toJump('供应商对账明细', url)
    }
  }
}
</script>

<style lang="less" scoped>
</style>